/**
 * Общие функции для работы с markdown и парсинга контента
 */
import type { Persona } from './pocketbase';

/**
 * Извлекает имя персоны из контента
 */
const COMMON_NON_NAME_WORDS = [
  'Приветствую', 'Здравствуйте', 'Привет', 'Добрый', 'Давайте', 'Рассмотрим',
  'Описание', 'Персона', 'Целевая', 'Аудитория', 'Target', 'Audience',
  'Базовый', 'Профиль', 'Психографический', 'Портрет', 'Проблематика',
  'Мотивация', 'Рекомендации', 'Введение', 'Маркетинговая',
  'Анализ', 'Результат', 'Создание', 'Структура',
];

export function extractPersonaName(persona: Persona): string {
  // If persona_name is set and is a real name (not a common word), use it
  if (
    persona.persona_name &&
    persona.persona_name !== 'Персона' &&
    !COMMON_NON_NAME_WORDS.includes(persona.persona_name)
  ) {
    return persona.persona_name;
  }

  const content = persona.generated_text || '';

  const namePatterns = [
    // "Имя: Анна" или "Имя и возраст: Анна, 32" (с HTML-тегами)
    /Имя(?:\s+и\s+возраст)?[^:]*?:\s*(?:<[^>]*>\s*)*([А-ЯЁA-Z][а-яёa-z]+)/i,
    // <strong>Анна</strong>, 32 года
    /<(?:strong|b)>\s*([А-ЯЁA-Z][а-яёa-z]+)\s*<\/(?:strong|b)>,?\s*\d+\s*(?:лет|год|года)/i,
    // **Анна**, 32 года
    /\*\*([А-ЯЁA-Z][а-яёa-z]+)\*\*,?\s*\d+\s*(?:лет|год|года|year|years)/i,
    // JSON "name": "Анна"
    /"name"\s*:\s*"([А-ЯЁA-Z][а-яёa-zА-ЯЁA-Z\s-]+)"/i,
    // Markdown заголовок с именем
    /^#{1,3}\s+([А-ЯЁA-Z][а-яёa-z]+)/m,
    // Паттерн "Имя: Анна" без HTML
    /(?:Имя|Name)[:\s]+([А-ЯЁA-Z][а-яёa-z]+)/i,
    // Представляем вам **Анна**
    /Представляем вам \*+([А-ЯЁA-Z][а-яёa-z]+)\*+/i,
  ];

  for (const pattern of namePatterns) {
    const match = content.match(pattern);
    if (match?.[1]) {
      const name = match[1].trim();
      if (!COMMON_NON_NAME_WORDS.includes(name)) {
        return name;
      }
    }
  }

  return 'Персона';
}
